import { getAccessToken } from './accessToken';
import { ensureAuthSession } from './ensureAuthSession';

/**
 * Minimal helper to centralize Authorization header injection for manual fetch calls.
 * - Uses credentials: include so HttpOnly cookies are sent in cookie auth mode
 * - Adds Authorization: Bearer <token> only if a token exists and header not already present
 * - Retries one 401 after refreshing the auth session
 * - Preserves all existing options and headers
 */
function buildFetchInit(init, token) {
  // Normalize headers to a Headers instance to avoid case issues
  const headers = new Headers(init.headers || {});

  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return {
    ...init,
    credentials: init.credentials || "include",
    headers,
  };
}

export async function authFetch(input, init = {}) {
  const response = await fetch(input, buildFetchInit(init, getAccessToken()));

  if (response.status !== 401) {
    return response;
  }

  const token = await ensureAuthSession({ forceRefresh: true });
  return fetch(input, buildFetchInit(init, token));
}

